function isChrome()
{
	return !!window.chrome && !!window.chrome.webstore;
}

function isWindows()
{
	return navigator.platform.indexOf('Win') > -1
}

function showNonFreeModal(resultName) {
  var nonFreeModal = $('#non-free-modal');
  nonFreeModal.find('.search-term').text(resultName);

  nonFreeModal.find('.modal-title span').text(resultName.length < 40 ? resultName : resultName.substring(0, 39) + '...');

  var mailToLink = nonFreeModal.find('.contact-us-link')
  .data('href')
  .replace(/%22%22/, '%22' + encodeURIComponent(resultName) + '%22');

  nonFreeModal.find('.contact-us-link')
  .attr('href', mailToLink);

  nonFreeModal.modal('show');
}

function showNonFreeModalSignIn(resultName) {
	var nonFreeModal = $('#non-free-modal-sign-in');

	nonFreeModal.find('.search-term').text(resultName);

	nonFreeModal.find('.modal-title span').text(resultName.length < 40 ? resultName : resultName.substring(0, 39) + '...');

	var mailToLink = nonFreeModal.find('.contact-us-link').data('href').replace(/%22%22/, '%22' + encodeURIComponent(resultName) + '%22');

	nonFreeModal.find('.contact-us-link').attr('href', mailToLink);

	nonFreeModal.modal('show');
}

function validatePurchaseState(usePurchaseApi) {
	if (userFullAccess)
		return true;
	if (userCredits > 0) {
		if (confirm('You have ' + userCredits + ' report(s) remaining. Would you like to use one for this item?')) {
			if(!usePurchaseApi)
				userFullAccess = true;
			else
			{
				var data = {};
				parse_str(window.location.search.substring(1), data);
				data.type = 'purchase_item';
				$.ajax({
					type: 'POST',
					data: data
				})
				.then(function(result)
				{
					if(result && result.success)
						userFullAccess = true;
					else
						alert('Failed to acquire report');
				})
				.catch(function(err)
				{
					alert('Failed to acquire report');
				})
			}
			return true;
		}

		return false;
	}

	let itemName = $('.item-stats-node-name,.item-stats-list-name').text();
  showNonFreeModal(itemName);
	//$("#pay-options-modal").modal('show');

	//window.location = '//insights.ranker.com/login/account/register?redirect=' + encodeURIComponent(window.location);

	return false;
}

$(function ()
{
	$('#export-modal').appendTo('body');
	$('#export-modal').on('show.bs.modal', function(e)
	{
		/*if (!validatePurchaseState(true))
		{
			e.preventDefault();
			return false;
		}*/
	});

	$(".tooltips").tooltip();

	/*$(".reg_odds").click(function ()
	{
		$(this).toggleClass('hidden');
		$(this).next(".low_odds").toggleClass('hidden');
	});

	$(".low_odds").click(function ()
	{
		$(this).toggleClass('hidden');
		$(this).prev(".reg_odds").toggleClass('hidden');
	});*/

	$(".hover_chart").hover(function ()
	{
		$(this).find('.show_graph').toggleClass('hidden');
	});

	var trivias = [];
	$('.ranking-trivia:not(.initialized)').each(function()
	{
		var that = $(this);
		var listId = that.data('listid');
		var nodeId = that.data('nodeid');

		trivias.push({elem: that,listId,nodeId});
	}).addClass('initialized');


	Promise.each(trivias,function(t)
	{
		return getTrivia(t.nodeId, t.listId, node && node.is_peoplish)
		.then(function (trivia)
		{
			if (trivia && trivia.length)
				t.elem.html(trivia);
		});
	});

	/*$(".toggler").click(function ()
	{
		$(this).parent().find(".low_odds").click();

		if ($(this).html() == "<span class=\"glyphicon glyphicon-refresh\"></span> Reg Odds")
		{
			$(this).html("<span class=\"glyphicon glyphicon-refresh\"></span> Low Odds");
		}
		else
		{
			$(this).html("<span class=\"glyphicon glyphicon-refresh\"></span> Reg Odds");
		}
	});*/

	$('.show_graph').click(function (e)
	{
		e.preventDefault();
		//get the data to show
		var data = $(this).next(".data_form").serialize();

		window.open('//insights.ranker.com/charts.php?' + data,
		'Ranker Chart Correlation',
		"toolbar=no, scrollbars=no, resizable=no, top=50, width=1200, height=900");
	});

	$('#horizontal-adjective-export,#standard-export,#full-export,#horizontal-export,#load-pdf-export,#pdf-export').click(
	function (e)
	{
    var that = $(this);

    if(!that.is('#pdf-export') && !validatePurchaseState(true))
    {
      $('#export-modal').modal('hide');
      e.preventDefault();
      return false;
    }

		var parent = that.parents('.export-form');
		var action = that.data('action');
		if (action)
			parent.attr('action', action);

		var method = that.data('method');
		if (method)
			parent.attr('method', method);

		if (parent.find('input[name="html"]') && !that.is('#pdf-export'))
			parent.find('input[name="html"]').attr('value', '');

		if (parent.find('input[name="html"]') && that.is('#pdf-export') && !parent.find('input[name="html"]').attr(
						'value').length)
		{
			if (window.export)
			{
				getExportHTML()
				.then(function (html)
				{
					parent.find('input[name="html"]').attr('value', html);
					parent.submit();
					setTimeout(function ()
					{
						parent.find('input[name="html"]').attr('value', '');
					}, 300)
				}, function (err)
				{
					alert('Encountered an error while exporting. Please notify an administrator.');
				});
			}
			else
			{
				window.location = window.location + '&interstitial=1&howto=1&export=1';
			}

			e.preventDefault();
		}

		$('#export-modal').modal('hide');
	});

	$('[data-toggle="popover"]').popover();

	$(document).on("click", ".popover .ui-icon-close", function ()
	{
		$(this).parents(".popover").popover('hide');
	});

	$('.admin-options-link').on('shown.bs.popover show.bs.popover', function ()
	{
		var value = $('#low-odds-high-odds-hidden').attr('value');

		var toCheck = $('.low-odds-high-odds-radio[value="' + value + '"]');
		toCheck.attr('checked','checked');
		$('.low-odds-high-odds-radio').not(toCheck).removeAttr('checked');

		if($('#picker').data('show-lists'))
			$('#ac-lists-toggle').attr('checked','checked');
		else
			$('#ac-lists-toggle').removeAttr('checked');
	});

	$('body').on('change', '.low-odds-high-odds-radio', function (e)
	{
		var that = $(this);
		setTimeout(function ()
		{
			if (that.is(':checked'))
			{
				$('#low-odds-high-odds-hidden').attr('value', that.attr('value'));

				var oddsClass = (that.attr('value') == '1' ? 'low_odds' : 'high_odds');
				var altOddsClass = (oddsClass == 'low_odds' ? 'high_odds' : 'low_odds');
				$('.' + oddsClass).css('display', '');
				$('.' + altOddsClass).css('display', 'none');
			}
		}, 50);
	}).on('change','#ac-lists-toggle',function()
	{
		var that = $(this);
		setTimeout(function ()
		{
			$('#picker').autocomplete('instance').resetCache(); // reset the autocomplete cache
			$('#picker').data('show-lists', that.is(':checked'));
		}, 50);
	})

});

var categoriesToIcons = {
	'1' : 'P',
	'3' : 'M',
	'4' : 'V',
	'5' : 'F',
	'7' : 'b',
	'8' : 't',
	'10': 'S',
	'11': 'T',
	'12': 's',
	'13': 'C',
	'14': 'f',
	'15': 'c',
	'16': 'B',
	'17': 'E',
	'19': 'A',
	'20': 'a',
	'24': 'G',
	'25': 'H',
	'-1': 'a'
};

function nodeCategoryToIcon(category_id)
{
	if(categoriesToIcons.hasOwnProperty(category_id))
		return categoriesToIcons[category_id];
	else
		return categoriesToIcons['-1'];
}

function fixJqueryDataConventions(data)
{
	var newData = {};

	Object.keys(data).forEach(function(i)
	{
		var newI = i.replace(/([a-z])([A-Z])/g, (match, p1, p2) => p1+'_'+p2.toLowerCase());
		newData[newI] = data[i];
	});

	return newData;
}

var earlyUiIinitialized = false;

function initializeEarlyUI()
{
	if(earlyUiIinitialized)
		return;
	else
		earlyUiIinitialized = true;

	function generateSeeListsData(node_id, audience, list_id, rel_node_id, adjective, node_name, imageURL, itemName, relNodeImageURL)
	{
		var itemType;
		var itemId;
		if (node_id)
		{
			itemType = 'id';
			itemId = node_id;
		}
		else if (audience)
		{
			itemType = 'audience';
			itemId = audience;
		}
		else if (list_id)
		{
			itemType = 'list_id';
			itemId = list_id
		}
		else
		{
			alert('Unable to determine item type');
			throw new Error('Unable to determine item type');
		}

		var data = {
			'id'                : `see-lists-${node_id}-${rel_node_id}`,
			'audience'          : audience,
			'list_id'           : list_id,
			'node_id'           : node_id,
			'rel_node_id'       : rel_node_id,
			'adjectives'        : htmlspecialchars(adjective),
			'rel_node_name'     : htmlspecialchars(node_name),
			'rel_node_image_url': htmlspecialchars(relNodeImageURL),
			'image_url'         : htmlspecialchars(imageURL),
			'item_type'         : itemType,
			'item_id'           : itemId,
			'item_name'         : htmlspecialchars(itemName)
		};

		return data;
	}

	function generateSeeListsLi(data)
	{
		var dataStr = '';

		for(let i in data)
		{
			if(!data.hasOwnProperty(i))
				continue;

			dataStr += ' data-'+i+'="'+data[i]+'"';
		}

		var seeListsLi = `<li class="relative see-lists rnkrBlue" ${dataStr}><span class="pointer">see lists</span></li>`;
		return seeListsLi;
	}

	function getPopUpData(that)
	{
		var node_id = that.data('node-id');
		var audience = that.data('audience');
		var rel_node_id = that.data('rel-node-id');
		var list_id = that.data('list-id');
		var node_name = that.data('node-name');
		var default_view = that.data('default-view');
		var class_id = that.data('class-id');
		var disambiguator = that.data('disambiguator');

		var adjective = false;
		var adjectiveTab = $('.nav-adjective.active');
		if (adjectiveTab.length && that.parents('.list-level-correlations-container').length == 0)
			adjective = adjectiveTab.data('adjective');
		var noReportRelationship = false;

		var imageURL = '';
		var itemName = '';
		var relNodeImageURL = '';
		if (that.parents('.list-col').length)
		{
			itemName = that.parents('.list-col').data('item-name') || '';
			imageURL = that.parents('.list-col').data('item-image-url') || '';
		}
		if (that.parents('.node-image-block').find('.node-image img').length)
		{
			relNodeImageURL = that.parents('.node-image-block').find('.node-image img').attr('src') || '';
		}
		return {node_id       : node_id,
			audience            : audience,
			rel_node_id         : rel_node_id,
			list_id             : list_id,
			node_name           : node_name,
			default_view        : default_view,
			class_id            : class_id,
			disambiguator       : disambiguator,
			adjective           : adjective,
			noReportRelationship: noReportRelationship,
			imageURL            : imageURL,
			itemName            : itemName,
			relNodeImageURL     : relNodeImageURL
		};
	}

	$('body').on('click','.report-flag,.node-image-gear-overlay',
	function(e)
	{
		var that = $(this);

		var {
		node_id,
		audience,
		rel_node_id,
		list_id,
		node_name,
		default_view,
		class_id,
		disambiguator,
		adjective,
		noReportRelationship,
		imageURL,
		itemName,
		relNodeImageURL
		} = getPopUpData(that);

		var isItemOptions = that.is('.node-image-gear-overlay');

		var listMode;
		var id;

		if(list_id && node_id)
		{
			listMode = true;
			id = 'report-node-'+node_id+'-list-'+list_id;
		}
		else if(node_id && rel_node_id)
		{
			listMode = false;
			id = 'report-node-' + node_id + '-node-' + rel_node_id;
		}
		else if (audience && rel_node_id)
		{
			listMode = false;
			id = 'report-audience-' + audience + '-node-' + rel_node_id;
			noReportRelationship = true;
		}
		else if (list_id && rel_node_id)
		{
			listMode = false;
			id = 'report-list-' + list_id + '-node-' + rel_node_id;
			noReportRelationship = true;
		}
		else
		{
			alert('invalid report link');
			return false;
		}

		if($('#'+id).length)
		{
			setTimeout(function()
			{
				$('#' + id).popup('open', {positionTo: that});
			},100);
			e.preventDefault();
			return false;
		}

		var popupTitle = (isItemOptions && adjective ? 'ITEM OPTIONS' : /*(listMode ?*/'REMOVE LIST'/* : 'REMOVE ITEM')*/);

		var removeFromGraphData = listMode ? `data-list-id="${list_id}"` : `data-node-id="${rel_node_id}"`;

		var removeRelationshipLi = '';
		if(!noReportRelationship)
		{
			var removeRelationshipData = listMode ? `data-list-id="${list_id}"` : `data-rel-node-id="${rel_node_id}"`;
			removeRelationshipLi = `<li class="relative report-remove rnkrBlue" data-node-id="${node_id}" ${removeRelationshipData}><span class="pointer">remove relationship</span></li>`;
		}

		var changeDefaultViewLi = `<li class="relative change-default-view rnkrBlue" data-node-id="${rel_node_id}" data-default-view="${default_view=='0'?6:0}"><span class="pointer">${default_view=='0'?'restore to' : 'remove from'} contracted view</span></li>`;

		var changeClassLi = `<li class="relative change-class rnkrBlue" data-node-id="${rel_node_id}" data-class="${class_id}"><span class="pointer">change class</span></li>`;

		var editDisambiguatorLi = `<li class="relative edit-disambiguator rnkrBlue" data-node-id="${rel_node_id}" data-disambiguator="${disambiguator}"><span class="pointer">edit disambiguator</span></li>`;

		var seeListsLi = '';
		if(isItemOptions && adjective && node_id)
		{
			var seeListsData = generateSeeListsData(node_id, audience, list_id, rel_node_id, adjective, node_name, imageURL, itemName, relNodeImageURL);
			seeListsLi = generateSeeListsLi(seeListsData);
		}

		var html = `<div data-role="popup" id="${id}" class="float repNodeBox whiteBg visible"><div class="boxTitle ranker-dark-blue-bg"><span class="float relative block repNodeFaux"><span class="relative common-icon white item-options-gear-icon">G</span></span><span class="float relative title white">${popupTitle}</span><a href="#" data-rel="back"><span class="floatRight relative ui-icon ui-icon-close white"></span></a></div><ul>${changeDefaultViewLi}${removeRelationshipLi}<li class="relative report-remove rnkrBlue" ${removeFromGraphData}><span class="pointer">remove from graph tool</span></li>${changeClassLi}${editDisambiguatorLi}${seeListsLi}</ul></div>`;

		$(html).data('report-element',that[0]).appendTo(that).popup({corners: false, history: false});

		setTimeout(function ()
		{
			$('#' + id).popup('open',{positionTo:that});
		}, 100);

		e.preventDefault();
		return false;
	});

	function showSeeListsModal(id, data, rel_node_name)
	{
		if ($('#' + id).length)
		{
			setTimeout(function ()
			{
				$('#' + id).modal('show');
			}, 100);
			//e.preventDefault();
			//return false;
		}

		var imageBlock = '';
		if (data.image_url && data.image_url.length)
		{
			imageBlock = `<div class="node-image-block"><div class="node-image"><img src="${(data.image_url)}"/></div></div>`;
		}

		var relImageBlock = '';
		if (data.rel_node_image_url && data.rel_node_image_url.length)
		{
			relImageBlock = `<div class="node-image-block"><div class="node-image"><img src="${(data.rel_node_image_url)}"/></div></div>`;
		}

		var standardCloseButton = `<button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>`;

		var whyBlock = '';
		var whyElem = $('.why-block').last();
		if (whyElem.length)
		{
			whyElem = whyElem.clone();
			whyElem.find('.why-header').append(standardCloseButton);
			standardCloseButton = '';
			whyBlock = whyElem[0].outerHTML
		}

		var html = `<div class="modal see-lists-modal fade" id="${id}" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
      ${whyBlock}
        <div class="modal-body-inner">
	        <div class="modal-title see-lists-header clearfix">
	            <div class="see-lists-header-col">
	                ${imageBlock}
	                <div class="see-lists-header-name-block">
						<div class="see-lists-voted-on">people who ${data.item_type == 'audience' ? 'are' : 'voted on'}</div>
		                <a href="?${data.item_type}=${data.item_id}&adjectives=any" class="see-lists-header-name">
		                    <span class="node-name">${htmlspecialchars(htmlspecialchars_decode(htmlspecialchars_decode(data.item_name)))}</span>
		                </a>
	                </div>
	            </div>
	            <img class="see-lists-pointerline" src="images/pointerline.png"/>
	            <div class="see-lists-header-col">
	                ${relImageBlock}
	                <div class="see-lists-header-name-block">
						<div class="see-lists-voted-on">also voted on</div>
		                <a href="?id=${data.rel_node_id}&adjectives=any" class="see-lists-header-name">
		                    <span class="node-name">${htmlspecialchars(htmlspecialchars_decode(rel_node_name))}</span>
		                </a>
	                </div>
	            </div>
	          ${standardCloseButton}
	        </div>
	        <div class="ajax-body"></div>
        </div>
      </div>
    </div>
  </div>
</div>`;


		$(html).appendTo('body').modal();

		setTimeout(function ()
		{
			$('#' + id).modal('show');
		}, 100);

		$('#' + id).find('.ajax-body').html(
		'<img src="images/ajax-loader.gif" style="margin-left: auto;margin-right: auto;display: block;"/>');

		data.id = data.node_id;
		delete data.node_id;

		$.ajax({
			url : window.location.pathname,
			data: data
		})
		.then(function (data)
		{
			if (!data || typeof data !== 'object' || !data.hasOwnProperty('html'))
				throw new Error(data);

			if ($('#' + id).length)
			{
				$('#' + id).find('.ajax-body').html(data.html);
			}
		}, function ()
		{
			$('#' + id).find('.ajax-body').html('<h2 class="text-danger">Error loading Lists</h2>');
			alert('Failed to load lists for this relationship');
		});
	}

	$('body').on('click', '.see-lists',
	function (e)
	{
		var that = $(this);

		var data = fixJqueryDataConventions(that.data());
		data.type = 'seelists';

		var id = data.id;
		data.id = undefined;
		var rel_node_name = data['rel_node_name'] || '';
		data['rel_node_name'] = undefined;

		that.parents('.ui-popup').popup('close');
		that.parents('.ui-popup').popup('close');

		showSeeListsModal(id, data, rel_node_name);

		e.preventDefault();
		return false;
	});

	$('body').on('change', '.common-uncommon-checkbox', function (e) {
		$(this).closest('.list-col').toggleClass('highlight-common-uncommon');
	});

	$('body').on('click', '.common-uncommon-info', function (e) {
		const $modal = $('#common-uncommon-info-modal');
		if ($modal.length) {
			setTimeout(function () {
				$modal.modal('show');
			}, 100);
			return false;
		}

		const html = `
        <div class="modal common-uncommon-info-modal fade" id="common-uncommon-info-modal" tabindex="-1" role="dialog">
		  <div class="modal-dialog" role="document">
			<div class="modal-content">
			  <div class="modal-body">
				<div class="modal-body-inner">
                  <div class="modal-title clearfix">
                    <div class="common-uncommon-modal-title">About <b>Highlight Relationships</b> <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button></div>
                  </div>
                  <div class="common-uncommon-modal__copy">Use this toggle to highlight the relationships that are expected and unexpected.</div>
                  <div class="common-uncommon-modal__legend common-uncommon-legend">
                      <div class="common-uncommon-legend__wrapper">
                        <div class="common-uncommon-legend__title">Highlight Color Legend</div>
                        <div class="common-uncommon-legend__colors-container">
                          <div class="common-uncommon-legend__color-wrapper">
                            <div class="common-uncommon-legend__color">
                              <div class="common-uncommon-legend__color-square" style="background: linear-gradient(45deg, rgba(255, 204, 0, 0.5) 0%, rgba(255, 204, 0, 0.15) 100%);"></div>
                            </div>
                            <div class="common-uncommon-legend__color-text">
                              <div class="common-uncommon-legend__color-title">Expected Relationship</div>
                              <div class="common-uncommon-legend__color-copy">Common characteristics</div>
                              <div class="common-uncommon-legend__color-copy">Scores <b>high</b> on content similarity</div>
                            </div>
                          </div>
                          <div class="common-uncommon-legend__color-wrapper">
                            <div class="common-uncommon-legend__color">
                              <div class="common-uncommon-legend__color-square" style="background: linear-gradient(45deg, rgba(0, 51, 255, 0.5) 0%, rgba(0, 51, 255, 0.15) 100%);"></div>
                            </div>
                            <div class="common-uncommon-legend__color-text">
                              <div class="common-uncommon-legend__color-title">Unexpected Relationship</div>
                              <div class="common-uncommon-legend__color-copy">Unique and Surprising</div>
                              <div class="common-uncommon-legend__color-copy">Scores <b>low</b> on content similarity</div>
                            </div>
                          </div>
                        </div>
                        <div class="common-uncommon-legend__footer">Important:  Relationships that appear without highlighting are also valid and significant.  We score content similarity on a spectrum.  A lack of highlightning simply means that the relationship falls in the middle and is neither notably expected or unexpected.</div>
                      </div>
				  </div>
				  <div class="common-uncommon-modal__explanation">
					<p><b>Why this matters</b></p>
					<p>Expected relationships are correlations that content experts tend to know intuitively.  Naturally we assume the ‘Harry Potter’ series of films to be strongly correlated with each other.  That’s expected.  However, it’s the unexpected relationships that we discover that can open new avenues for audience targeting, potentially extending your reach and efficiency.</p>
					<p>This is where Ranker data excels.  All of our correlations are based on psychographic voting patterns across millions of users.  This enables us to identify unique audience relationships using real voter affinities at scale.</p>
					<p><b>How it works</b></p>
					<p>We calculate expected relationships with a proprietary scoring algorithm that calculates content similarity.  We then classify relationships with the highest shared similarity scores.  While our correlations are calculated purely on psychographic voting data, this filter enables you to segment these results on what’s expected and unexpected.</p>
					<p>This option is available for Premium users only.  It applies to correlations in the TV and Film categories.</p>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		</div>`;

		$(html).appendTo('body').modal();
	});

	$('body').on('click', '.why-see-lists',
	function (e)
	{
		var that = $(this).closest('.list-row').find('.node-image-gear-overlay,.node-options-data-holder');

		var {
		node_id,
		audience,
		rel_node_id,
		list_id,
		node_name,
		adjective,
		imageURL,
		itemName,
		relNodeImageURL
		} = getPopUpData(that); // TODO FIX THAT reference

		var data = generateSeeListsData(node_id,
		audience,
		list_id,
		rel_node_id,
		adjective,
		node_name,
		imageURL,
		itemName,
		relNodeImageURL);

		data.type = 'seelists';

		var id = data.id;
		data.id = undefined;
		var rel_node_name = data['rel_node_name'] || '';
		data['rel_node_name'] = undefined;

		showSeeListsModal(id, data, rel_node_name);

		e.preventDefault();
		return false;
	});

	$('body')
	.on('click', '.change-class', function(e)
	{
		e.preventDefault();
		var that = $(this);

		if (!that.data('class_id') || !that.data('class_id').length)
		{
			var data = $('#main-node-data-holder').data();
			if (data && data.class) {
				that.data('class_id', data.class);
			} else {
				that.data('class_id', '');
			}
		}

		var data = fixJqueryDataConventions(that.data());

		var modal = $(`#change-class-modal`);

		modal.find(`select[name="class_id"] > option`).removeAttr('selected');
		modal.find(`select[name="class_id"] [value="${data.class_id}"]`).attr('selected','selected');
		modal.find('input[name="node_id"]').attr('value',data.node_id);

		that.parents('.ui-popup').popup('close');
		that.parents('.ui-popup').popup('close');

		modal.modal('show');
	})
	.on('submit', '.change-class-form', function (e)
	{
		var that = $(this);
		var select = $('[name="class_id"]', that);

		$('#change-class-modal').modal('hide');
		select.blur();

		$.ajax({
			type: 'POST',
			url : that.attr('action'),
			data: that.serialize()
		})
		.then(function (data)
		{
			if (!data || data.error)
				alert('Encountered error while changing class');
		})
		.fail(function ()
		{
			alert('Encountered error while changing class');
		});

		e.preventDefault();
		return false;
	})
	.on('click', '.edit-disambiguator', function (e)
	{
		e.preventDefault();
		var that = $(this);

		if (!that.data('disambiguator'))
		{
			var data = $('#main-node-data-holder').data();
			if (data && data.disambiguator) {
				that.data('disambiguator', data.disambiguator);
			} else {
				that.data('disambiguator', '');
			}
		}

		var data = fixJqueryDataConventions(that.data());

		var modal = $(`#edit-disambiguator-modal`);

		modal.find('input[name="disambiguator"]').attr('value', data.disambiguator);
		modal.find('input[name="node_id"]').attr('value', data.node_id);

		that.parents('.ui-popup').popup('close');
		that.parents('.ui-popup').popup('close');

		modal.modal('show');
	})
	.on('submit', '.edit-disambiguator-form', function (e)
	{
		var that = $(this);

		$('#edit-disambiguator-modal').modal('hide');

		$.ajax({
			type: 'POST',
			url : that.attr('action'),
			data: that.serialize()
		})
		.then(function (data)
		{
			if (!data || data.error)
				alert('Encountered error while changing class');
		})
		.fail(function ()
		{
			alert('Encountered error while changing class');
		});

		e.preventDefault();
		return false;
	});

	// Remove the modal after it has been closed to manage DOM size
	$('body').on('hidden.bs.modal', '.modal.see-lists-modal', function ()
	{
		$(this).remove();
	});

	$('body').on('shown.bs.modal', '.modal.see-lists-modal', function()
	{
		$('.see-lists-header-name').each(function ()
		{
			if ($(this).height() >= 44)
				$(this).css('margin-top', '-2px').prevAll('.see-lists-voted-on').css('margin-top', '-3px');
		});
	});

	$('body').on('click', '.change-default-view', function (e)
	{
		var that = $(this);

		var data = fixJqueryDataConventions(that.data());

		if (that.parents('.ui-popup').length && that.parents('.ui-popup').popup)
		{
			that.parents('.ui-popup').popup('close');
			that.parents('.ui-popup').popup('close');
		}

		var isRemove = data.default_view=='0';

		if (isRemove && !confirm('Are you sure you want to remove this item from the contracted view?'))
		{
			e.preventDefault();
			return false;
		}

		$.ajax({
			url    : 'changeDefaultView.php',
			type   : 'GET',
			data   : data,
			timeout: 5000
		})
		.then(function ()
		{
			$('#item-' + that.data('node-id')).find('.report-flag,.node-image-gear-overlay').data('default-view', isRemove?'0':'1');
		},
		function (e)
		{
			console.log(JSON.stringify(e));
			if (!e || !e.statusText || e.statusText != 'timeout')
				alert('Failure while changing default view status');
		});

		e.preventDefault();
		return false;
	});

	$('body').on('click','.report-remove',function(e)
	{
		var that = $(this);

		var data = fixJqueryDataConventions(that.data());

		var isSelfRemove = that.is('.report-remove-self');

		if(that.parents('.ui-popup').length && that.parents('.ui-popup').popup)
		{
			that.parents('.ui-popup').popup('close');
			that.parents('.ui-popup').popup('close');
		}

		if(data.node_id && data.rel_node_id)
		{
			if (!confirm('Are you sure you want to remove this item to item relationship?'))
			{
				e.preventDefault();
				return false;
			}
		}
		else if(data.node_id && data.list_id)
		{
			if (!confirm('Are you sure you want to remove this item/list relationship?'))
			{
				e.preventDefault();
				return false;
			}
		}
		else if(data.node_id)
		{
			if (!confirm('Are you sure you want to remove this item from the graph completely?'))
			{
				e.preventDefault();
				return false;
			}
		}
		else if(data.list_id)
		{
			if (!confirm('Are you sure you want to remove this list from the graph completely?'))
			{
				e.preventDefault();
				return false;
			}
		}
		else if (!confirm('Are you sure you want to remove this item/list?'))
		{
			e.preventDefault();
			return false;
		}


		$.ajax({
			url: 'removeRelationship.php',
			type: 'GET',
			data:data,
			timeout:5000
		})
		.then(function()
		{
			if(isSelfRemove)
				window.location.reload();
		},
		function(e)
		{
			console.log(JSON.stringify(e));
			if(!e || !e.statusText || e.statusText != 'timeout')
				alert('Failure while removing item/list');
		});



		e.preventDefault();
		return false;
	});

	// Remove the popup after it has been closed to manage DOM size
	$(document).on("popupafterclose", ".ui-popup", function ()
	{
		$(this).remove();
	});


	$('body').on('click','.plus-more',function(e, extraData)
	{
		if (!isPreviewItem && !validatePurchaseState())
		{
			e.preventDefault();
			return false;
		}

		var that = $(this);

		var data = fixJqueryDataConventions(that.data());
		data.type = 'loadmore';
		data.id = data.node_id;

		if(window.location.search && window.location.search.length && /algo=kr2/.test(window.location.search)) {
			data.algo = 'kr2';
		}

		delete data.node_id;

		var limit = (data.limit ? parseInt(data.limit) : 0);

		var blueTriangle = that.find('.blue-triangle');

		if(!blueTriangle.length)
		{
			e.preventDefault();
			return false;
		}

		var outerParent = that.parents('.list-col');

		var numItems = outerParent.find('.list-row').length;

		if(that.hasClass('see-less'))
		{
			if (window.export)
			{
				var exportSelectedIds = [];
				var groupHeaderHTML = outerParent.find('.group-header').first()[0].outerHTML;

				outerParent.find('.list-row').filter('.export-selected').each(function ()
				{
					exportSelectedIds.push($(this).attr('id'));
				});
			}

			var seeLessDiv = that.parents('.see-less-div');
			that.removeClass('see-less');
			seeLessDiv.removeClass('see-less-div').addClass('plus-more-div').insertBefore(seeLessDiv.prev('.group-footer-shadow'));
			outerParent.html(outerParent.data('orig-html'));
      outerParent.data('orig-html',null);

			if (window.export)
			{
				outerParent.find('.group-header').replaceWith(groupHeaderHTML);
				outerParent.find('.export-selected').removeClass('export-selected');
				for (var i = 0; i < exportSelectedIds.length; i++)
				{
					$('#' + exportSelectedIds[i]).addClass('export-selected');
				}
			}

			$('html, body').animate({
				scrollTop: outerParent.offset().top
			}, 500);

			e.preventDefault();
			return false;
		}

		if(!outerParent.data('orig-html')) {
      var orig = outerParent.html();
      outerParent.data('orig-html', orig);
		}

		var plusMoreDiv = that.parents('.plus-more-div');
		var plusMoreDivHTML = plusMoreDiv[0].outerHTML;

		that.html('<img src="images/ajax-loader.gif"/>');
		plusMoreDiv.removeClass('plus-more-div').addClass('see-less-div').insertAfter(plusMoreDiv.next('.group-footer-shadow'));

		data.limit += numItems;

		$.ajax({
			url: window.location.pathname,
			data: data
		})
		.then(function(data)
		{
			if (!data || typeof data !== 'object' || !data.hasOwnProperty('html'))
				throw new Error(data);

			var listRows = outerParent.find('.list-row');

			var exportSelectedIds = [];
			if(window.export)
			{
				listRows.filter('.export-selected').each(function()
				{
					exportSelectedIds.push($(this).attr('id'));
				});
			}

			listRows.remove();

			outerParent.find('.list-row-wrapper').remove();
			outerParent.find('.group-header-divider').after(data.html);

			var newListRows = outerParent.find('.list-row');
			var numItems = newListRows.length;

			var totalItems = parseInt(outerParent.data('total-items'));

			if(limit && totalItems > numItems)
			{
				outerParent.find('.see-less-div').replaceWith(plusMoreDivHTML);

				if(totalItems - numItems <= limit) {
          outerParent.find('.plus-more-text-span').text('load all '+number_format(totalItems));
				}
			}
			else {

				var origListRows = $(outerParent.data('orig-html')).find('.list-row');
				var origNumItems = origListRows.length;
        that.html('see top '+ origNumItems+' <span class="blue-triangle"></span>').addClass('see-less');
      }


			/*if(window.export)
			{
				if(window.export.makeFourColumns)
					window.export.makeFourColumns(outerParent);
			}*/
			setRowHeights(outerParent);

			if (extraData && extraData.callback)
				extraData.callback();
			else if(window.export)
			{
				newListRows.removeClass('export-selected');
				for(var i = 0; i < exportSelectedIds.length; i++)
				{
					$('#'+ exportSelectedIds[i]).addClass('export-selected');
				}
			}

			if (data.itemLimit) {
				outerParent.closest('.list-col').find('.common-uncommon-counters .in-screen').text(data.itemLimit);
			}

			outerParent.find(".tooltips").tooltip();
		}
		,function()
		{
			that.find('img').replaceWith('<span class="blue-triangle"></span>');
			alert('Failed to load more items');
		});

		e.preventDefault();
		return false;
	});

	$('body').on('click','.audience-more',function(e, extraData)
	{
		/*if (!validatePurchaseState())
		{
			e.preventDefault();
			return false;
		}*/

		var that = $(this);

		var data = fixJqueryDataConventions(that.data());
		data.type = 'loadaudience';

		var blueTriangle = that.find('.blue-triangle');

		if (!blueTriangle.length)
		{
			e.preventDefault();
			return false;
		}

		var parent = $('.audience-affinity');

		if (that.hasClass('see-less'))
		{
			if (window.export)
			{
				var origHeader = parent.find('.audience-header').html();
				var exportSelectedIds = [];

				parent.find('.export-selected').each(function ()
				{
					exportSelectedIds.push($(this).attr('id'));
				});
			}

			parent.html(parent.data('orig-html'));

			if (window.export)
			{
				parent.find('.export-selected').removeClass('export-selected');
				for (var i = 0; i < exportSelectedIds.length; i++)
				{
					$('#' + exportSelectedIds[i]).addClass('export-selected');
				}
				parent.find('.audience-header').html(origHeader);
			}

			that.html(that.data('orig-html'));
			that.removeClass('see-less');

			e.preventDefault();
			return false;
		}

		parent.data('orig-html', parent.html());
		that.data('orig-html',that.html());

		that.html('<img src="images/ajax-loader.gif"/>');

		setTimeout(function()
		{
			$.ajax({
				url : window.location.pathname,
				data: data
			})
			.then(function (data)
			{
				if (!data || typeof data !== 'object' || !data.hasOwnProperty('html'))
					throw new Error(data);

				var origHtml = parent.data('orig-html');

				if (window.export)
				{
					var parentSelected = parent.hasClass('export-selected');
					var origHeader = parent.find('.audience-header').html();
					var exportSelectedIds = [];

					parent.find('.export-selected').each(function ()
					{
						exportSelectedIds.push($(this).attr('id'));
					});
				}

				parent.replaceWith(data.html);

				parent = $('.audience-affinity'); // fixing parent as it is reset with the above line

				parent.data('orig-html', origHtml);

				that.html(`
				<div class="audience-more-text-div">
					<span class="audience-more-text-span">see less</span><span class="blue-triangle"></span>
				</div>`);
				that.addClass('see-less');



				if (extraData && extraData.callback)
					extraData.callback();
				else if (window.export)
				{
					parent.find('.export-selected').removeClass('export-selected');
					for (var i = 0; i < exportSelectedIds.length; i++)
					{
						$('#' + exportSelectedIds[i]).addClass('export-selected');
					}
				}

				if(window.export)
				{
					if(parentSelected)
						parent.addClass('export-selected');
					else
						parent.removeClass('export-selected');

					parent.find('.audience-header').html(origHeader);

					if(window.export.wrapAudienceAffinity)
						window.export.wrapAudienceAffinity();
				}

			}, function ()
			{
				that.remove();
				alert('Failed to load more audience data');
			});
		},50);


		e.preventDefault();
		return false;
	});

	window.onpageshow = function (event)
	{
		$('.common-uncommon-checkbox').each((index, checkbox) => {
			const $checkbox = $(checkbox);
			const $listCol = $checkbox.closest('.list-col');
			const isHighlighting = $listCol.hasClass('highlight-common-uncommon');
			const isChecked = $checkbox.is(':checked');
			if ( isChecked !== isHighlighting ) {
				if ( isHighlighting ) {
					$checkbox.attr('checked','checked');
				} else {
					$checkbox.removeAttr('checked');
				}
			}
		});
	}

	window.onpopstate = function (event)
	{
		if(event.state && event.state.adjective)
		{
			$('.nav-adjective[data-adjective="'+ event.state.adjective+'"]:not(.active) a').trigger('click',{onpopstate:true});
		}
	};

	$('body').on('click', '.toggle-menu-on-click', function (e, extraData)
	{
		const target = $('.main-menu-dropdown');
		const isActive = target.hasClass('active');
		if (isActive) {
			if (window.reloadMenuOnClose) {
				window.location.reload();
			}
		}
		target.toggleClass('active');
	});

	$('body').on('click', '.toggle-active-on-parent', function (e, extraData)
	{
		const that = $(this);
		that.parent().toggleClass('active');
	});

	$('body').on('click', '.toggle-active-on-self', function (e, extraData)
	{
		const that = $(this);
		that.toggleClass('active');
	});

	$('body').on('click', '.header-hamburglar.toggle-active-on-parent', function (e, extraData)
	{
		const that = $(this);
		const isActive = that.parent().hasClass('active');
		if (!isActive) {
			if (window.reloadMenuOnClose) {
				window.location.reload();
			}
			that.parent().find('.active').removeClass('active');
		}
	});

	$('body').on('click', '.nav-adjective a', function (e, extraData)
	{
		var that = $(this);

		var data = {};
		var href = that.attr('href');
		parse_str(href.replace(/^[^?]*\?/, ''),data);
		data.type = 'loadadjective';

		var loadingGif = that.find('.adjective-loader');

		var parent = that.closest('.nav-adjective');

		if (loadingGif.length || parent.hasClass('active')) // currently running
		{
			e.preventDefault();
			return false;
		}

		if (history && (!extraData || !extraData.onpopstate))
		{
			history.replaceState({adjective: parent.siblings('.active').data('adjective')}, document.title || "", window.location);
			history.pushState({adjective: data.adjectives}, document.title || "", href);
		}

		parent.addClass('active').siblings('.nav-adjective.active').removeClass('active');

		var startTime = Date.now();

		$('.findings-container,.love-hate-subheader')
		.fadeTo(350,0, function()
		{
			$('.love-hate-subheader').remove();

			$('.findings-container').html(
			`<div class="adjective-loader">
			<img src="images/ajax-loader.gif">
		</div>`)
		})
		.fadeTo(350, 1);

		$.ajax({
			url : window.location.pathname,
			data: data
		})
		.then(function (data)
		{
			if (!data || typeof data !== 'object' || !data.hasOwnProperty('html'))
			{
				alert('Error while loading adjective based correlations');
				throw new Error(data);
			}

			$('.findings-container')
			.delay(Math.max(0,1200 - (Date.now() - startTime)))
			.fadeTo(350, 0, function ()
			{
				if (data.success)
				{
					$('.love-hate-div').remove();
				}

				$('.adjective-loader').remove();

				var newFindings = $(data.html);
				newFindings.find('.findings-container').css('opacity', 0);
				$('.findings-container').replaceWith(newFindings);
				$('.findings-container').fadeTo(350, 1);
			});

			$('#export-modal input[name="adjectives"]').attr('value',data.adjectives);

			setRowHeights();
		},
		function ()
		{
			$('.adjective-loader').remove();
			$('.findings-container').html(`<h2>Error while loading correlations</h2>`).css('opacity',1);

			alert('Failed to load adjective based correlations');

			window.location = that.attr('href');
		});

		e.preventDefault();
		return false;
	});

	var nicheRunning = false;

	$('body').on('click','.set-niche-link',function(e)
	{
		var that = $(this);

		if(nicheRunning)
		{
			e.preventDefault();
			return false;
		}
		nicheRunning = true;

		var listid = that.data('listid');
		var nicheVal = that.data('nicheval');

		var data = {
			listid: listid, action: 'niche', value: nicheVal
		};

		data[csrfKey] = csrfToken;

		$.ajax({
			url:'changeNiche.php',
			type: 'POST',
			data: data
		})
		.then(function ()
		{
			nicheRunning = false;

			window.location.reload();
		},
		function ()
		{
			nicheRunning = false;

			alert('Error while setting/unsetting list to/from niche');
		});

		e.preventDefault();
		return false;
	});

	var sameListHtml = null;
	var crossListHtml = null;

	$('body').on('click', '.mode-button.mode-ajax', function (e)
	{
		var that = $(this);

		var data = fixJqueryDataConventions(that.data());
		data.type = 'loadlistlevel';

		$('.mode-link').html('<img src="images/ajax-loader.gif"/>');

		$.ajax({
			url : window.location.pathname,
			data: data
		})
		.then(function (data)
		{
			if (!data || typeof data !== 'object' || !data.hasOwnProperty('html'))
				throw new Error(data);

			sameListHtml = data.html;
			$('.list-level-correlations-container').html(data.html);
			$('.mode-link-div').remove();
		}
		, function ()
		{
			$('.mode-link-div').remove();
			alert('Failed to load list level correlations');
		});

		e.preventDefault();
		return false;
	});


	$('body').on('click', '.nav-list-level a', function (e)
	{
		var that = $(this);

		if(!$('.list-level-correlations-container').length)
			return;

		if(that.parent('.nav-list-level').is('.active'))
		{
			e.preventDefault();
			return false;
		}

		$('.nav-list-level.active').removeClass('active');
		that.parent('.nav-list-level').addClass('active');

		var data = fixJqueryDataConventions(that.data());

		if(data.samelist == '1' && sameListHtml !== null)
		{
			$('.list-level-correlations-container').html(sameListHtml);
			e.preventDefault();
			return false;
		}
		else if (data.samelist == '0' && crossListHtml !== null)
		{
			$('.list-level-correlations-container').html(crossListHtml);
			e.preventDefault();
			return false;
		}

		data.type = 'loadlistlevel';

		var samelist = data.samelist;

		$('.list-level-tabs-container').nextAll().remove();
		$('.list-level-tabs-container').after('<div class="text-center" style="height:200px;margin-top:200px"><img src="images/ajax-loader.gif"/></div>');

		$.ajax({
			url : window.location.pathname,
			data: data
		})
		.then(function (data)
		{
			if (!data || typeof data !== 'object' || !data.hasOwnProperty('html'))
				throw new Error(data);

			if(samelist)
				sameListHtml = data.html;
			else if(crossListHtml)
				crossListHtml = data.html;

			$('.list-level-correlations-container').html(data.html);
		}
		, function ()
		{
			$('.list-level-tabs-container').nextAll().remove();
			alert('Failed to load list level correlations');
		});

		e.preventDefault();
		return false;
	});
}

function regionPieChartReady()
{
	var parent = $(this).parents('.demographic-map-region-pie-chart');
	var regionId = parent.data('region-id');
	parent.find('text').remove();
	simplemaps_usmap.mapdata.regions[regionId].description = parent.html();
	parent.remove();
}

function drawCharts()
{
	$('.votes-pie-chart').not('.done').each(function ()
	{
		var that = this;
		$(that).addClass('done');

		var elementData = fixJqueryDataConventions($(that).data());
		var data = google.visualization.arrayToDataTable([
			['Vote Type', 'Votes'],
			['Down Votes', elementData.downvotes],
			['Up Votes', elementData.upvotes]
		]);

		var positiveColor = '#1e3e66';
		var negativeColor = '#b81507';

		var options = {
			backgroundColor  : 'transparent',
			pieSliceText     : 'percentage',
			pieSliceTextStyle: {fontSize: '13', fontName: 'Arial, Helevtica, sans-serif'},
			legend           : 'none',
			width            : elementData.width || '200',
			height           : elementData.height || '200',
			enableInteractivity: !elementData.hasOwnProperty('interactive') || elementData.interactive?true:false,
			slices           : {
				0: {color: negativeColor},
				1: {color: positiveColor}
			}
		};

		var chart = new google.visualization.PieChart(that);
		chart.draw(data, options);

		setTimeout(function()
		{
			$('.demographic-pie-chart > div > div:first-child').css('width', '150px').css('height', '150px').find('svg').attr('width','165').attr('height','165');
		});


		var fixDecimals = function ()
		{
			var refreshElement = false;

			var hasThumbs = false;
			var texts = $(that).find('text').each(function ()
			{
				var that = $(this);

				if(that.data('thumb')){
					hasThumbs = true;
					return;
				}

				var isPositive = that.prev().attr('fill') == positiveColor;

				var text = that.text();
				text = text.replace(/&nbsp;/g, '');
				if (/^[0-9.%]+$/.test(text))
				{
					var nbsps = '&nbsp;';
					if((isPositive || !elementData.add_thumbs) && (!elementData.width || elementData.width === 200))
						nbsps += '&nbsp;';

					that.html(nbsps+ Math.round(parseFloat(that.text().replace(/[^0-9.]/,
					''))) + '%');
					refreshElement = true;
				}
				else if (/^[0-9]+\s*\([0-9.]+%\)/.test(text))
				{
					var matches = text.match(/^([0-9]+)\s*\(([0-9.]+)%\)/);
					var total = number_format(matches[1]);
					var percent = Math.round(parseFloat(matches[2]));
					if(elementData.hide_votes)
						that.html('    '+percent + '%');
					else
						that.html(total + ' (' + percent + '%)');

					refreshElement = true;
				}
			});

			if(!hasThumbs && elementData.add_thumbs && !window.export) //disabled in export mode due to font issues
			{

				texts.each(function()
				{
					var that = $(this);
					var isPositive = that.prev().attr('fill') == positiveColor;

					var text = that.text();
					text = text.replace(/&nbsp;|%/g, '');

					if(parseFloat(text) < 25)
						return;

					var origX = parseFloat(that.attr('x'));
					var origY = parseFloat(that.attr('y')) + 8;
					var thumbX = origX+(isPositive?8:4);
					var thumbY = origY-15;

					var sign = isPositive?'+':'-';

					that.attr('y',origY);

					// TODO fixme font doesnt work in webshot and falls back to category for some reason

          var html = `<text text-anchor="start" x="${thumbX}" y="${thumbY}" font-family="RankerIconsCommon-Regular, RankerIconsCommon" font-size="22" stroke="none" stroke-width="0" fill="#ffffff" data-thumb="true">${sign}</text>`;

          $(this).after(html);

					refreshElement = true;
				});
			}

			if (refreshElement)
				$(that).html($(that).html());
		};

		if(elementData.onready)
		{
			google.visualization.events.addListener(chart, 'ready', window[elementData.onready].bind(that));
		}

		google.visualization.events.addListener(chart, 'ready', fixDecimals);
		google.visualization.events.addListener(chart, 'onmouseover', fixDecimals);
		google.visualization.events.addListener(chart, 'onmouseout', fixDecimals);
		google.visualization.events.addListener(chart, 'click', fixDecimals);
		google.visualization.events.addListener(chart, 'select', fixDecimals);

		setTimeout(function ()
		{
			fixDecimals.apply(chart);
		},100);
	});
}

//window.drawCharts = drawCharts;

function setRowHeights(listRowParent)
{
	if (!listRowParent)
		listRowParent = $('.list-col');

	listRowParent.find('.list-row-wrapper').each(function ()
	{
		var that = $(this);
		var maxHeight = 0;
		that.find('.list-row').each(function ()
		{
			var g = $(this);
			maxHeight = Math.max(maxHeight, g.outerHeight());
		})
		.css('height', maxHeight + 'px');

		//that.css('height', maxHeight + 'px');
	});
}

async function getTrivia(nodeId, listId, isPerson)
{
	try
	{
		var data = {
			type : 'trivia',
			list_id: listId,
			id     : nodeId
		};

		let result = await $.ajax({
			type: 'GET',
			data
		});

		if (!result || !result.success || !result.trivia || !result.trivia.triviaType)
			throw new Error('invalid response');

		return renderTrivia(result.trivia, isPerson);
	}
	catch(err)
	{
		console.log(err);
		console.log('Failed to load trivia for node '+nodeId+' on list '+listId);
	}

	return '';
}

function renderTrivia(trivia, isPerson)
{
	var html = '';

	switch (trivia.triviaType)
	{
		case 'CORRELATED' :
		case 'CORRELATED_DIFF_CATEGORY' :
		case 'CORRELATED_DIFF_CLASS' :
			html = 'People were also fans of ' + trivia.textTwo + ' on';
			break;

		case 'CORRELATED_WORST' :
		case 'CORRELATED_WORST_DIFF_CATEGORY' :
		case 'CORRELATED_WORST_DIFF_CLASS' :
			html = 'People also down-voted ' + trivia.textTwo + ' on';
			break;

		case 'CORRELATED_WITHINLIST' :
			html = 'Fans of ' + trivia.nodeName + ' are <strong>' + trivia.textOne + 'x</strong> more likely to be fans of <em>' + trivia.textTwo + '</em> on this list';
			break;

		case 'CORRELATED_WORST_WITHINLIST' :
			html = 'People who down-vote ' + trivia.nodeName + ' are <strong>' + trivia.textOne + 'x</strong> more likely to down-vote <em>' +
			trivia.textTwo + '</em> on this list';
			break;

		case 'DEMOGRAPHICS' :
			if(trivia.textOne.match(/^People in the /))
			{
				trivia.textOnePrefix = 'People in the ';
				trivia.textOne = trivia.textOne.replace(/^People in the /,'');
			}
			else
				trivia.textOnePrefix = '';

			html = trivia.textOnePrefix+'<strong>'+trivia.textOne + '</strong> are <strong>' + trivia.textTwo + 'x</strong> more likely to rank this '+(isPerson?'person ':'')+'high on';
			break;

		/*case 'RANKED' :
		case 'RANKED_WORST' :
			html = '<strong>' + trivia.nodeName + '</strong> also ranks #' + trivia.textOne + ' on' + linkStart + trivia.textThree + linkEnd;
			break;*/

	}

	return html;
}